<script>
    //import TopAppBar, {Row, Section, Title} from '@smui/top-app-bar';
    import _get from "lodash/get";
    import IconButton from '@smui/icon-button';
    import Checkbox from '@smui/checkbox';
    import FormField from '@smui/form-field';

    import Chip, {Set, Checkmark} from '@smui/chips';
    //import Button, {Label, Icon} from '@smui/button';
    import Button from "../components/form/Button.svelte";
    import List, {Item, Text, Graphic, Separator, Subheader} from '@smui/list';
    import { AppContent } from '@smui/drawer';

    import ProjectCard from "../components/ProjectCard.svelte";
    import CompanyCard from "../components/CompanyCard.svelte";
    import DashboardMenuDrawer from "../components/DashboardMenuDrawer.svelte";
    import Overlay from "../components/Overlay.svelte";
    import WelcomeDialog from "../components/dialogs/WelcomeDialog.svelte";
    import NewCompanyDialog from "../components/dialogs/NewCompanyDialog.svelte";
    import NewParticipaidProjectDialog from "../components/dialogs/NewParticipaidProjectDialog.svelte";
    import Name from "../components/Name.svelte";
    import DrawerToggleButton from "../components/DrawerToggleButton.svelte";
    import DashboardSection from "../components/DashboardSection.svelte";
    import Background from "../components/Background.svelte";
    import UserMenu from "../components/menu/UserMenu.svelte";
    import LoadingSpinner from "../components/LoadingSpinner.svelte";
    import LoadingModal from "../components/LoadingModal.svelte";

    import { client, gql } from "../GraphQL.svelte";
    import { FIELDS_CONTENT_FRAGMENT } from "../Participaid.svelte";
    import { userInfo } from "../Me.svelte";
    import { createEventDispatcher } from 'svelte';
    import { fly } from 'svelte/transition';
    import { navigate } from "svelte-routing";

    //
    // constants
    //

    // TODO: wrap into some kind of standardized eventbus
    const dispatch = createEventDispatcher();

    // raw query tpl
    const DASHBOARD_QUERY = gql`
        query {
            me {
                user {
                    firstName,
                    emailAddress,
                    id
                },
                companies {
                    id,
                    creationTime,
                    eyeventureUrl,
                    name,
                    websiteUrl
                },
                contributingProjects {
                    creationTime,
                    companyValuation,
                    id,
                    description,
                    avatarUrl,
                    isClosed,
                    isSettled,
                    title,
                    settlementDateTarget,
                    fields { name },
                    company {
                        name
                    },
                    contributions {
                        id, tags
                    },
                    contributors {
                        id,
                        title,
                        commissionPercentage,
                        hourlySalary,
                        marketAnnualSalary,
                        user {
                            id, avatarUrl
                        }
                    }
                }
            }
        }
    `;

    const mainBackgrounds = [
        "/images/backgrounds/mountain1.jpg",
        "https://c4.wallpaperflare.com/wallpaper/202/691/681/matterhorn-mountains-nature-landscape-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/446/319/706/landscape-mountains-snow-snowy-peak-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/758/252/42/firewatch-video-games-mountains-nature-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/600/360/964/digital-art-landscape-forest-mountains-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/55/157/309/mountains-cliff-peak-doi-inthanon-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/333/691/669/rock-formation-on-brown-field-during-daytime-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/578/978/337/landscape-photography-of-mountain-surrounded-by-trees-berchtesgaden-berchtesgaden-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/650/686/462/signage-showing-right-turn-10-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/740/445/308/mountains-the-game-people-forest-wallpaper-preview.jpg",
    ];

    //
    // settable properties
    //

    // alternatives:
    // https://www.goodfon.com/download/vector-blue-squares-abstract-background-geometric/2560x1440/
    //
    export let backgroundOverlay = "rgba(255, 255, 255, 0.85)";
    export let loadingBackground = "random";

    //
    // internal properties
    //

    let backgroundComponent;

    // will be loaded using gql
    let model;

    // the request that will be loading the data
    let dataRequest;

    // flag for New Project dialog
    let showNewParticipaidProjectDialog = false;

    // dialog for creating new company
    let showNewCompanyDialog = false;

    // because deep-observing objects like Model doesnt work
    let companies = [];
    let projects = [];
    let meUser;

    // configuration of company filters
    // TODO: move to own component because we also need company filters
    let companiesFilter = ['Active', 'Deleted', 'Invited'];
    let companiesFilterActive = [
        'Active',
        //'Deleted',
        'Invited'
    ];

    // configuration of project filters
    // TODO: move to own component because we also need company filters
    let projectsFilter = ['ParticipAid', 'ValueAid', 'TeamAid', 'Owner', 'Coworker', 'Settled', 'Closed'];
    let projectsFilterActive = [
        'ParticipAid',
        //'ValueAid',
        //'TeamAid',
        'Owner',
        'Coworker',

        ...companies.map(comp => projectFilterNameForCompany(comp))
    ];

    //
    // functions
    //

    const closeDialogs = () =>
          showWelcomeDialog
        = showNewParticipaidProjectDialog
        = showNewCompanyDialog
        = false
        ;

    const handleCreateProject = () => showWelcomeDialog = true;

    const handleCompanyCreated = () => {
        reload();
        showNewCompanyDialog = false;
    };

    const handleProjectCreated = (event) => {
        console.log(`[Dashboard] received confirmation of Project having been created!`);
        console.log(event);

        reload();
        showNewParticipaidProjectDialog = false;
        navigate(`/p/${event.detail.id}`, { replace: true });
    };

    const handleNetworkError = (res) => {
        console.debug("[Dashboard] handling network error... Should arrive in App.");
        dispatch('networkError', res);
    }

    function updateFilters() {
        console.log(`updating filters...`);
        companies.forEach(company => {
            let tag = projectFilterNameForCompany(company);
            if (!projectsFilter.includes(tag)) {
                projectsFilter = [...projectsFilter, tag];

                if (!projectsFilterActive.includes(tag)) {
                    projectsFilterActive = [...projectsFilterActive, tag];
                }
            }
        });
    }

    function projectFilterNameForCompany(company) {
        return `Company: ${company.name}`;
    }

    function isProjectFiltered(project) {
        return !projectsFilterActive.includes(
            projectFilterNameForCompany(project.company)
        );
    }

    function cycleBackground() {
        console.log(`[Dashboard] Cycling background image...`);
        backgroundComponent.next();
    }

    // TODO: refactor into much more incremental features
    // reload per project, company, object type etc
    function reload() {
        console.log("[Dashboard] reloading data...");

        dataRequest = client.query({
            query: DASHBOARD_QUERY,
            variables: {},
            // https://medium.com/@galen.corey/understanding-apollo-fetch-policies-705b5ad71980
            fetchPolicy: "network-only"
        })

        // set model on success
        .then(res => {
            model = res.data;
            companies = model.me.companies;
            projects = model.me.contributingProjects;
            meUserId = model.me.user.id;
            updateFilters();
            dispatch("loaded");
        })

        // propagate network error to App on error
        .catch(handleNetworkError);
    }

    reload();

    //
    // derived properties
    //

    // for data model
    $: hasProjects = !!projects.length;
    $: hasCompanies = !!companies.length;
    $: meUserId = meUser && meUser.id;
    $: isAdmin = meUser && meUser.emailAddress.toLowerCase().endsWith("@eyevestor.com");

    $: projectCount = projects.length;
    $: visibleProjects = projects.filter(project => {
        //return projectsFilterActive && !isProjectFiltered(project);
        return true;
    });
    $: hasVisibleProjects = !!visibleProjects.length;

    // dialogs
    $: isNewUser = !hasProjects && !hasCompanies;
    $: showWelcomeDialog = isNewUser;
    $: showDialog = model && (showWelcomeDialog || showNewParticipaidProjectDialog || showNewCompanyDialog);
    $: overlayClosable = model && (hasProjects || hasCompanies);

    // meta
    $: drawerOpened = !showDialog;
    $: loading = !!!model;
    $: pageTitle = (loading) ? "Loading dashboard..." : "Dashboard";

    $: {
        console.log(`project filter changed!`);
        console.log(projectsFilterActive);
    }

</script>

<!-- set HTML template title for this route -->
<svelte:head>
    <title>Evalueaid | {pageTitle}</title>
</svelte:head>

<Background images={mainBackgrounds} parallax content="random" loaderBackground="#fff" bind:this={backgroundComponent}/>
<Background content={backgroundOverlay} parallax loaderBackground="#fff"/>

<div class="drawer-container">
    <DashboardMenuDrawer
            opened="{drawerOpened}"
            {isAdmin}
            on:newProjectPlease={handleCreateProject}
            on:newBackgroundPlease={cycleBackground}/>

    <AppContent class="app-content" id="dashboard-drawer-content">
        <main class="main-content" style="position: relative">
            <UserMenu style="position: absolute; right: 0; top: 0; margin: 20px;"/>
<!--            <Background images={mainBackgrounds} parallax content="random" loaderBackground="#fff"/>-->
<!--            <Background content={backgroundOverlay} parallax />-->

            <DrawerToggleButton on:click={() => drawerOpened = !drawerOpened}/>
            <br />
            <h1>
                Welcome back <Name/>!
            </h1>

            <!-- TODO: make copmonent -->
            <DashboardSection id="dashboard-companies">
                <h2>
                    Your companies ({(companies || []).length})
                    <Button on:click={() => showNewCompanyDialog = true} style="padding: 0px 10px; margin-left: 10px;"><small>add new</small></Button>
                </h2>
                <Set chips={companiesFilter} let:chip filter bind:selected={companiesFilterActive} style="position: relative; left: -10px; display: none;">
                    <Chip tabindex="0"><Checkmark /><Text>{chip}</Text></Chip>
                </Set>
                <div class="card-container">
                    {#await dataRequest}
                        <p>loading...</p>
                    {:then}
                        {#if hasCompanies}
                            {#each companies as company}
                                <CompanyCard model="{company}" on:deleted={reload}/>
                            {/each}
                        {:else}
                            <p>No companies yet... <a href="#" on:click={() => showNewCompanyDialog = true}>Create your first company</a></p>
                        {/if}
                    {/await}
                </div>

            </DashboardSection>

            <!--  TODO: make component -->
            <DashboardSection id="dashboard-projects">
                <h2>
                    Your Partipies ({projectCount})
                    <Button on:click={handleCreateProject} style="padding: 0px 10px; margin-left: 10px;"><small>add new</small></Button>
                </h2>
                <Set chips={projectsFilter} let:chip filter bind:selected={projectsFilterActive} style="position: relative; left: -10px; display: none;">
                    <Chip tabindex="0"><Checkmark /><Text>{chip}</Text></Chip>
                </Set>
                <div class="card-container">
                    {#await dataRequest}
                        <p>loading...</p>
                    {:then}
                        {#if !hasProjects}
                            <p>No projects yet... <a href="#" on:click={handleCreateProject}>Create your first project</a></p>
                        {:else if !hasVisibleProjects}
                            <p>All your projects are hidden by filters. <a href="#" on:click={() => projectsFilterActive = projectsFilter}>Show all</a></p>
                        {:else}
                            {#each visibleProjects as project}
                                <span class="project-card-wrapper">
                                    <ProjectCard
                                            model={project}
                                            on:newContributor={reload}
                                            on:deleted={reload}
                                            {meUserId}
                                    />
                                </span>
                            {/each}
                        {/if}
                    {/await}
                </div>
            </DashboardSection>
        </main>
    </AppContent>
</div>

<!-- TODO: use some kind of switch statement using a single enum to switch dialog states -->
<Overlay show={showDialog} closable={overlayClosable} on:close={closeDialogs} background={loadingBackground} loaderBackground="#FFF"}>
    <WelcomeDialog
            show={showWelcomeDialog}
            showActions={!loading}
            {isNewUser}
            on:new={() => { showNewParticipaidProjectDialog = true; showWelcomeDialog = false }}
    />

    <NewParticipaidProjectDialog
             show={showNewParticipaidProjectDialog}
             on:newProject={handleProjectCreated}
             on:newCompany={reload}
             id="dialog-new-project"
             {companies}
        />

    <NewCompanyDialog
            on:new={handleCompanyCreated}
            show={showNewCompanyDialog}/>
</Overlay>

{#if loading}
    <LoadingModal
            show={loading}
            loaderBackground="#fff"
            content="#fff"
            lightSpinner />
{/if}

<footer></footer>

<style>
    .drawer-container {
        position: relative;
        display: flex;
        height: 100%;
        overflow: hidden;
        z-index: 0;
    }

    .card-container {
        display: flex;
        flex-wrap: wrap;
    }

    :global(.main-content) {
        padding-left: 25px;
    }

    :global(.card-container > .project-card-wrapper .mdc-card), :global(.card-container > .mdc-card) {
        margin-right: 25px;
        margin-bottom: 75px;
    }

    :global(#dashboard-drawer-content) {
        //padding-left: 25px;
        position: relative;
        overflow-x: hidden;
    }

    :global(#dashboard-drawer-content .mdc-chip--selected) {
        background: #90f490;
    }

    :global(#dashboard-drawer-content .mdc-chip-set) {
        margin-bottom: 15px;
    }
</style>